import React from "react";
import { graphql, Link, Slice } from "gatsby";
import NavigationBar from "../../components/NavigationBar";
import {
  Typography,
  Container,
  Box,
  IconButton,
  Unstable_Grid2 as Grid,
  Chip,
  Card,
  CardContent,
  CardMedia,
} from "@mui/material";

import { Facebook, Share, ShareRounded, Twitter } from "@mui/icons-material";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { CardActionArea } from "gatsby-theme-material-ui";
import DonationArticle from "../../components/DonationArticle";
import { adData, TopBanner } from "../../components/TopBanner";
import { Banner300x250 } from "../../components/RectangleBanner";
import { Banner300x600 } from "../../components/banners/Banner300x600";

export const TextCard = ({ to, category, date, title }) => (
  <Card sx={{ mb: 1 }}>
    <CardActionArea to={to}>
      <CardContent sx={{ padding: "12px !important" }}>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          sx={{ mb: 0.75 }}
        >
          <Chip label={category.toUpperCase()} color="primary" size="small" />
          <Box>{date}</Box>
        </Box>
        <Typography fontWeight={"bold"}>{title}</Typography>
      </CardContent>
    </CardActionArea>
  </Card>
);

export const TextCardStack = ({ articles }) => (
  <>
    <Typography variant="h5" fontWeight={"bold"} mb={1.5}>
      Последни вести
    </Typography>
    {articles.map((article) => (
      <TextCard
        to={article.slug}
        category={article.frontmatter.category}
        date={article.frontmatter.date}
        title={article.frontmatter.title}
      />
    ))}
  </>
);

const getShareUrl = () => encodeURIComponent(window.location.href);

const handleFacebookShare = () => {
  const url = `https://www.facebook.com/sharer/sharer.php?u=${getShareUrl()}`;
  window.open(url, "_blank", "noopener,noreferrer");
};

const handleTwitterShare = () => {
  const url = `https://twitter.com/intent/tweet?url=${getShareUrl()}`;
  window.open(url, "_blank", "noopener,noreferrer");
};

function SocialShareButtons() {
  return (
    <>
      <IconButton onClick={handleFacebookShare}>
        <Facebook fontSize="large" />
      </IconButton>
      <IconButton onClick={handleTwitterShare}>
        <Twitter fontSize="large" />
      </IconButton>
    </>
  );
}

export default function Template({ data, location, pageContext, ...rest }) {
  const { markdownRemark } = data;
  const { frontmatter } = markdownRemark;
  return (
    <div>
      <NavigationBar
        rightIcon={
          <IconButton
            onClick={() => {
              if (navigator.share) {
                navigator
                  .share({
                    title: frontmatter.title,
                    url: location.href,
                    text: frontmatter.excerpt,
                  })
                  .catch(console.error);
              } else {
              }
            }}
          >
            <Share />
          </IconButton>
        }
      />
      <TopBanner />
      <Container sx={{ mt: 3 }}>
        <Grid container spacing={3}>
          <Grid xs={12} md={8}>
            <Card>
              <Box sx={{ m: { lg: 3, xs: 1.5 } }}>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Chip
                    label={data.markdownRemark.frontmatter.category.toUpperCase()}
                    color="primary"
                    size="small"
                  />
                </Box>
                <Typography
                  variant="h4"
                  fontWeight={800}
                  textAlign={"center"}
                  sx={{ mt: { lg: 2, xs: 1.5 }, mb: { lg: 2, xs: 1.5 } }}
                >
                  {data.markdownRemark.frontmatter.title}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    mb: { lg: 2, xs: 1.5 },
                  }}
                >
                  <Typography>
                    {data.markdownRemark.frontmatter.date}
                  </Typography>
                  {/* <Typography sx={{ ml: 1 }}>
                    • {data.markdownRemark.timeToRead} мин четене
                  </Typography> */}
                  <Typography sx={{ ml: 1 }}>
                    • од {data.markdownRemark.frontmatter.author}
                  </Typography>
                </Box>
                <Box display={"flex"} justifyContent={"center"}>
                  <SocialShareButtons />
                  <IconButton
                    onClick={() => {
                      if (navigator.share) {
                        navigator
                          .share({
                            title: data.markdownRemark.frontmatter.title,
                            url: location.href,
                            text: data.markdownRemark.frontmatter.excerpt,
                          })
                          .catch(console.error);
                      }
                    }}
                  >
                    <ShareRounded />
                  </IconButton>
                </Box>
              </Box>
              <GatsbyImage
                image={getImage(data.markdownRemark.frontmatter.featuredImage)}
              />
              <Box sx={{ m: 3, userSelect: "none" }}>
                <Typography
                  component="div"
                  dangerouslySetInnerHTML={{
                    __html: data.markdownRemark.html,
                  }}
                />
                {/* <CryptoDonations /> */}
              </Box>
              <DonationArticle />
            </Card>
            <Slice alias={`more-from-category`} />
          </Grid>
          <Grid xs={12} md={4}>
            {/* <Box display="flex" justifyContent={"center"}>
              <StaticImage
                src="https://www.cik.bg/upload/205590/300_250_1_tur.png"
                alt="избори"
              />
            </Box> */}
            <Box sx={{ mb: 1 }}>
              <Banner300x250 products={adData} />
            </Box>
            <Slice alias="latest-articles" />
            {/* <Box display="flex" justifyContent={"center"}>
              <Banner300x600 products={adData} />
            </Box> */}
          </Grid>
        </Grid>
      </Container>
      {/* <Footer /> */}
    </div>
  );
}

export function Head({ pageContext, data, location }) {
  return (
    <>
      <title>{pageContext.frontmatter__title}</title>
      <meta name="title" content={pageContext.frontmatter__title} />
      <meta name="description" content={data.markdownRemark.excerpt} />

      <meta property="og:type" content="article" />
      <meta
        property="article:section"
        content={pageContext.frontmatter__category}
      />
      <meta
        property="og:url"
        content={`${
          process.env.NODE_ENV === "development"
            ? "http://localhost:8000"
            : "https://vestimak.mk"
        }${location.pathname}`}
      />
      <meta property="og:title" content={pageContext.frontmatter__title} />
      <meta property="og:description" content={data.markdownRemark.excerpt} />
      {
        <meta
          property="og:image"
          content={`${
            process.env.NODE_ENV === "development"
              ? "http://localhost:8000"
              : "https://vestimak.mk"
          }${
            data.markdownRemark.frontmatter.featuredImage?.childImageSharp
              ?.gatsbyImageData?.images?.fallback?.src
          }`}
        />
      }

      <meta property="twitter:card" content="summary_large_image" />
      <meta
        property="twitter:url"
        content={`${
          process.env.NODE_ENV === "development"
            ? "http://localhost:8000"
            : "https://vestimak.mk"
        }${location.pathname}`}
      />
      <meta property="twitter:title" content={pageContext.frontmatter__title} />
      <meta
        property="twitter:description"
        content={data.markdownRemark.excerpt}
      />
      {
        <meta
          property="twitter:image"
          content={`${
            process.env.NODE_ENV === "development"
              ? "http://localhost:8000"
              : "https://vestimak.mk"
          }${
            data.markdownRemark.frontmatter.featuredImage?.childImageSharp
              ?.gatsbyImageData?.images?.fallback?.src
          }`}
        />
      }
    </>
  );
}

export const pageQuery = graphql`
  query ($id: String!) {
    markdownRemark(id: { eq: $id }) {
      gatsbyPath(
        filePath: "/{MarkdownRemark.frontmatter__category}/{MarkdownRemark.frontmatter__title}"
      )
      excerpt(pruneLength: 170)
      html
      # timeToRead
      frontmatter {
        category
        title
        author
        featuredImage {
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
          }
        }
        date(formatString: "DD MMMM YYYY", locale: "mk-MK")
      }
    }
  }
`;
